import type { ReactNode } from "react";
import Container from "@/components/Container/Container";
import HeroAccent, { type AccentVariant } from "@/components/HeroAccent/HeroAccent";
import styles from "./PageHero.module.css";

type PageHeroProps = {
  eyebrow?: string;
  title: string;
  intro?: ReactNode;
  accent?: AccentVariant;
};

export default function PageHero({ eyebrow, title, intro, accent = "bloom" }: PageHeroProps) {
  return (
    <section className={styles.hero}>
      <Container width="default" className={styles.inner}>
        <div className={styles.copy}>
          {eyebrow ? <span className="eyebrow">{eyebrow}</span> : null}
          <h1 className={styles.title}>{title}</h1>
          {intro ? <p className={styles.intro}>{intro}</p> : null}
        </div>
      </Container>
      {/* Accent lives OUTSIDE the Container so it can pin to the section's
          true right and top edges, not the constrained content rail. */}
      <div className={styles.accentSlot} aria-hidden="true">
        <HeroAccent variant={accent} />
      </div>
    </section>
  );
}
